import {
  IconoirCheckCircle,
  IconoirTimer,
  IconoirInfoCircle,
} from "@ey-xd/motif-icon";
import { MotifIcon } from "@ey-xd/motif-react";
import { FocusEventHandler, KeyboardEventHandler, PointerEventHandler, Ref } from "react";
import { ApprovalStatus } from "./status";

interface ApprovalStatusBadgeProps {
  label: string;
  status: ApprovalStatus;
  isExpanded: boolean;
  triggerRef: Ref<HTMLDivElement>;
  onBlur: FocusEventHandler<HTMLDivElement>;
  onClick: () => void;
  onFocus: FocusEventHandler<HTMLDivElement>;
  onKeyDown: KeyboardEventHandler<HTMLDivElement>;
  onPointerEnter: PointerEventHandler<HTMLDivElement>;
  onPointerLeave: PointerEventHandler<HTMLDivElement>;
  tooltipId?: string;
}

const ApprovalStatusBadge = ({
  label,
  status,
  isExpanded,
  triggerRef,
  onBlur,
  onClick,
  onFocus,
  onKeyDown,
  onPointerEnter,
  onPointerLeave,
  tooltipId,
}: ApprovalStatusBadgeProps) => {
  const icon =
    status === "approved"
      ? IconoirCheckCircle
      : status === "rejected"
        ? IconoirInfoCircle
        : IconoirTimer;
  const badgeClass = status === "approved" ? "completed" : status;

  return (
    <div
      ref={triggerRef}
      className={`status-badge ${badgeClass} approval-status-popover__trigger`}
      role="button"
      tabIndex={0}
      aria-describedby={tooltipId}
      aria-expanded={isExpanded}
      onBlur={onBlur}
      onClick={onClick}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
    >
      <span className="status-badge-label approval-status-popover__trigger-label">
        {label}
      </span>
      <MotifIcon iconFunction={icon} size="16" />
    </div>
  );
};

export default ApprovalStatusBadge;
